import * as React from "react";
import {ILabtestPrescription, IDiagnosticLabTestItem} from "@curefit/care-common";
import {LOADING_STATE} from "../../utils/AppUtils"
import EditViewCard, {EditViewDisplayMode} from "../../components/common/EditViewCard"
import AppLoader from "../../components/utils/AppLoader"
import * as _ from "lodash"
import ModelFactory from "../../models/ModelFactory"
import {PatientLabTestsViewProps} from "../../components/patient/view/PatientDiagnosticLabTestsView"
import {LabTestEditorProps} from "../../components/patient/edit/PatientDiagnosticLabTestsEditor"
import { IAddMetric } from "@curefit/metrics-common";
import {AppMessages} from "../../utils/AppConstants";

/**
 * Created by aditya on 06/02/18.
 */

export interface LabTestEditViewContProps {
    patientId: number,
    consultationType?: string,
    patientLabTest: IDiagnosticLabTestItem[],
    fetchStaticLabTests?: (input: string) => Promise<any>,
    savePatientDiagnosticLabTests: (req: ILabtestPrescription[]) => Promise<any>;
    savePatientLabTests: (patientLabTests: ILabtestPrescription[]) => any,
    fetchLabTests?: (patientId: number) => any,
    displayMode?: EditViewDisplayMode,
    curefitUserId: number;
    saveEditedPatientTests: (labTests: IDiagnosticLabTestItem[]) => void;
    hideLabTestForm: () => void,
    handleInvalidItemError: (sectionText: string, errorText?: string) => void
}

export interface LabTestEditViewContState {
    updatedLabTest: {item: IDiagnosticLabTestItem}[],
    isPatientLabTestDataLoaded: LOADING_STATE,
    deletedLabTestIds: number[],
    isSaving: boolean
}

class LabTestEditViewCont extends React.Component<LabTestEditViewContProps, LabTestEditViewContState> {

    constructor(props: LabTestEditViewContProps) {
        super(props);
        this.state = this.getStateFromProps(props);
    }

    componentWillReceiveProps(props: LabTestEditViewContProps) {
        this.setState(this.getStateFromProps(props));
    }

    getUpdatedLifeStyleFromProps = (props: LabTestEditViewContProps): {item: IDiagnosticLabTestItem}[] => {
        let currUpdatedLabTest: {item: IDiagnosticLabTestItem}[] = [];
        _.map(props.patientLabTest, function(labTest){
            let clonePatientLabTest = Object.assign({}, labTest);
            currUpdatedLabTest.push({item: clonePatientLabTest});
        });
        return currUpdatedLabTest;
    }

    getStateFromProps = (props: LabTestEditViewContProps) => {
        let currState: LabTestEditViewContState = {
            updatedLabTest: [],
            isPatientLabTestDataLoaded: LOADING_STATE.NOT_INITIALIZED,
            deletedLabTestIds: [],
            isSaving: false
        }
        if ( _.isNull(props.patientLabTest)) {
            props.fetchLabTests(this.props.patientId);
            currState.isPatientLabTestDataLoaded = LOADING_STATE.LOADING;
        } else {
            currState.updatedLabTest = [];
            if (!_.isEmpty(props.patientLabTest)) {
                _.map(props.patientLabTest, function(labTest){
                    let clonePatientLabTest = Object.assign({}, labTest, {name: labTest.metric ? labTest.metric.name : labTest.name}, {metricId: labTest.metric ? labTest.metric.id : labTest.metricId});
                    currState.updatedLabTest.push({item: clonePatientLabTest});
                });
            }
            currState.isPatientLabTestDataLoaded = LOADING_STATE.LOADED;
        }
        return currState;
    }

    getLabTestEditViewTemplateProps = () => {
        let patientLabTestViewProps: PatientLabTestsViewProps = {
            labTest: this.props.patientLabTest
        }
        let patientLabTestEditorProps: LabTestEditorProps = {
            consultationType: this.props.consultationType,
            fetchStaticDiagnosticLabTests: this.props.fetchStaticLabTests,
            updatedLabTest: this.state.updatedLabTest,
            updateLabTest: this.updatePatientLabTest,
            patientId: this.props.patientId,
            curefitUserId: this.props.curefitUserId,
            labTest: this.state.updatedLabTest,
            savePatientDiagnosticLabTests: this.savePatientDiagnosticLabTests,
            isSaving: this.state.isSaving,
            hideLabTestForm: this.props.hideLabTestForm
        }
        return {"view": patientLabTestViewProps, "edit": patientLabTestEditorProps};
    }

    updatePatientLabTest = (updatedLabTest: {item: IDiagnosticLabTestItem}[]) => {
        let mapping: {[key: number]: IDiagnosticLabTestItem} = {}
        let deletedLabTestIds: number[] = []
        updatedLabTest.map((labTest: {item: IDiagnosticLabTestItem}) => {
            mapping[labTest.item.id] = labTest.item;
        })
        this.props.patientLabTest.map((labTest: IDiagnosticLabTestItem) => {
            if (!(mapping[labTest.id])) {
                deletedLabTestIds.push(labTest.id);
            }
        })
        this.setState({updatedLabTest, deletedLabTestIds});
    }

    savePatientDiagnosticLabTests = () => {
        let updatedLabTestObject = this.getSaveObject();
        // let editedOrAddedLabTests: ILabtestPrescription[] = this.getEditedOrAddedLabTests();
        let deletedLabTestIds = this.getDeletedLabTestIds();
        this.props.saveEditedPatientTests(updatedLabTestObject);
        // this.props.updateDiagnosticLabTests(updatedLabTestObject.diagnosislabTests);
        if (!this.isFormDirty()) {
            this.setState({isSaving: true});
            this.props.savePatientDiagnosticLabTests(updatedLabTestObject).then(() => {
                this.setState({ isSaving: false });
                this.props.hideLabTestForm();
                // if (deletedLabTestIds.length === 0) {
                // this.props.nextTab();
                // }
            }).catch((err: any) => {
                this.setState({ isSaving: false });
                this.props.handleInvalidItemError(AppMessages.LAB_TESTS_SAVE_ERROR, err.message)
            });
            // if (deletedLabTestIds.length > 0) {
            //     this.props.deletePatientDiagnosticLabTests(deletedLabTestIds).then(function(){
            //         myInstance.setState({isSaving: true, error: null});
            //         myInstance.props.nextTab();
            //         console.log("Successfully Saved Medical Profile");
            //     }).catch((err: any) => {
            //         this.setState({
            //             error: AppMessages.LAB_TESTS_SAVE_ERROR,
            //             errorDetails: err.message,
            //             isSaving: false
            //         })
            //     });
            // }

        } else {
            this.props.handleInvalidItemError("Lab Tests", "Diagnostic Test or Recorded Value missing for one or more lab tests.");
        }
    }

    cancelActionHandler = () => {
        this.setState({updatedLabTest: this.getUpdatedLifeStyleFromProps(this.props)});
    }

    getSaveObject = (): IDiagnosticLabTestItem[] => {
        let saveLabTestList: IDiagnosticLabTestItem[] = [];
        _.map(this.state.updatedLabTest, function(updatedLabTestItem: {item: IDiagnosticLabTestItem}){
            // if (ModelFactory.isValidLabTest(updatedLabTestItem.item)) {
                saveLabTestList.push(updatedLabTestItem.item);
            // }
        });
        return saveLabTestList;
    }

    getDeletedLabTestIds = () => {
        return [...this.state.deletedLabTestIds];
    }

    isFormDirty = (): boolean => {
        let status = false;
        _.map(this.state.updatedLabTest, function(updatedLabTestItem: {item: IDiagnosticLabTestItem}){
            if (!ModelFactory.isValidDiagnosticLabTest(updatedLabTestItem.item)) {
                status = true;
                return false;
            }
        })
        return status;
    }

    render() {
        let isLabTestDataLoaded =  this.state.isPatientLabTestDataLoaded === LOADING_STATE.LOADED;
        return (
            <div className="labTest-editview-cont">
                {
                    isLabTestDataLoaded &&
                    <EditViewCard cardTitleDisplay={"Lab test"} templateName={"diagnosticLabtest"}
                                  templateProps={this.getLabTestEditViewTemplateProps()}
                                  lastEditedEpoch={new Date().getTime()} saveActionHandler={this.savePatientLabTest}
                                  cancelActionHandler={this.cancelActionHandler} displayMode={this.props.displayMode}
                    />
                }
                {
                    !isLabTestDataLoaded &&
                    <AppLoader/>
                }
            </div>
        );
    }
}

export default LabTestEditViewCont;